/* ------------------------------------------------------------------
   Force external links inside buttons and the footer to open in a
   new tab. Runs once on DOMContentLoaded and re-runs when the
   sidecart / other sections are refreshed so newly-rendered links
   get the same treatment.

   Scope:
     - Any anchor inside <footer> or an element with a class matching
       [class*="footer"] (covers `.footer-2026`, `.footer`, etc.).
     - Any anchor styled as a button — matched via class name substring
       "button" or "btn", or wrapped in a `.button` container.

   Definition of "external":
     - href starts with `http://` or `https://` AND
     - the URL's host differs from `window.location.host`.
   Anything else (relative paths, mailto:, tel:, hash fragments) is
   left alone.
   ------------------------------------------------------------------ */
(function () {
  var host = window.location.host;

  var SELECTORS = [
    'footer a',
    '[class*="footer"] a',
    'a.button',
    '.button a',
    'a[class*="btn"]',
    '[class*="btn"] a',
    // Button-styled call-to-action anchors (e.g. .heritage-2026__cta,
    // .mega-menu__button, .ai-testimonials-carousel__cta-*, etc.).
    'a[class*="cta"]',
  ].join(', ');

  function isExternal(href) {
    if (!href) return false;
    if (!/^https?:\/\//i.test(href)) return false;
    try {
      var url = new URL(href, window.location.origin);
      return url.host && url.host !== host;
    } catch (e) {
      return false;
    }
  }

  function markExternal(a) {
    if (a.__externalMarked) return;
    var href = a.getAttribute('href');
    if (!isExternal(href)) return;
    a.setAttribute('target', '_blank');
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
    a.setAttribute('rel', rel.join(' '));
    a.__externalMarked = true;
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTORS).forEach(markExternal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Re-scan when the sidecart or other sections refresh so links
  // rendered after the initial load also get the target treatment.
  document.addEventListener('cart:refreshed', function () { scan(); });

  // Belt-and-braces — observe body-level mutations so any Ajax-loaded
  // content picks up the same behaviour without needing to fire the
  // custom event. Guarded by `MutationObserver` availability.
  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function (mutations) {
      var seen = false;
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (seen) return;
          if (node.nodeType === 1) seen = true;
        });
      });
      if (seen) scan();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
